import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-mobile-toolbar',
  imports: [MatToolbarModule, MatIconModule, MatButtonModule],
  templateUrl: './mobile-toolbar.component.html',
  styleUrl: './mobile-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileToolbarComponent {
  @Input() drawer: MatDrawer;
}
